import oc from 'open-color'

let colors
colors = oc
colors.offwhite = '#FAFAFD'
colors.wetasphalt = '#34495e'
colors.midnightblue = '#2c3e50'
colors.concrete = '#95a5a6'
colors.asbestos = '#7f8c8d'
colors.clouds = '#ecf0f1'
colors.silver = '#bdc3c7'
export default colors



// WEBPACK FOOTER //
// ./src/theme/colors.js